<template lang="pug">
#discount.right-panel.md-elevation-1
  .md-layout
    .md-layout-item
      md-button.md-accent.md-dense(v-bind:to="{ name: 'Discounts', query: $route.query }") Отмена
    .md-layout-item.md-layout.md-alignment-top-right
      md-button.md-primary.md-dense(@click="saveDiscount") Сохранить
  md-field(v-bind:class="{ 'md-invalid': errors.has('discount_type') }")
    label Тип скидки*
    md-select(v-model="discount.discount_type" name="discount_type" v-validate="'required'")
      md-option(value="1") Числовая
      md-option(value="2") Процентная
  md-field(v-bind:class="{ 'md-invalid': errors.has('period') }")
    label Длительность скидки*
    md-select(v-model="discount.period" name="period" v-validate="'required'")
      md-option(value="constant") Постоянная
      md-option(value="period") Период
    span.md-error(v-show="errors.has('period')") {{ errors.first('period') }}
  md-field(v-bind:class="{ 'md-invalid': errors.has('date_from'), 'md-has-value': discount.date_from }" v-show="discount.period == 'period'")
    label Дата начала
    datetime(v-model="discount.date_from" input-class="md-input" type="date" v-bind:use12-hour="false" v-bind:week-start="1" v-bind:phrases="{ ok: 'Ок', cancel: 'Отмена' }")
    md-button.md-icon-button.md-dense(@click="discount.date_from = ''"): md-icon close
    span.md-error(v-show="errors.has('date_from')") {{ errors.first('date_from') }}
  md-field(v-bind:class="{ 'md-invalid': errors.has('date_to'), 'md-has-value': discount.date_to }" v-show="discount.period == 'period'")
    label Дата окончания
    datetime(v-model="discount.date_to" input-class="md-input" type="date" v-bind:use12-hour="false" v-bind:week-start="1" v-bind:phrases="{ ok: 'Ок', cancel: 'Отмена' }")
    md-button.md-icon-button.md-dense(@click="discount.date_to = ''"): md-icon close
    span.md-error(v-show="errors.has('date_to')") {{ errors.first('date_to') }}

  z-input(
    v-model="discount.discount_value" label="Значение скидки" name="discount_value" id="discount_value"
    v-validate="'required'" v-bind:required="true" v-bind:error="errors.first('discount_value')"
  )
 
  z-input(
    v-model="discount.name" label="Название" name="name" id="name"
    v-validate="'required'" v-bind:required="true" v-bind:error="errors.first('name')"
  )
 
  md-field(v-bind:class="{ 'md-invalid': errors.has('description') }")
    label Описание
    md-textarea(v-model="discount.description" name="description")
    span.md-error(v-show="errors.has('description')") {{ errors.first('description') }}
  md-field(v-bind:class="{ 'md-invalid': errors.has('customers_group_id') }")
    label Группа пользователей*
    md-select(v-model="discount.customers_group_id" name="customers_group_id" v-validate="'required'")
      md-option(v-for="group in customerGroups" v-bind:key="group.id" v-bind:value="group.id") {{ group.name }}
    span.md-error(v-show="errors.has('discount_type')") {{ errors.first('customers_group_id') }}
  md-checkbox(v-model="discount.active" value="1") Скидка активна
</template>

<script>
import Autocomplete from '@/components/autocomplete'
import ZInput from '@/components/ZInput';
export default {
  components: {
    Autocomplete, ZInput
  },
  data() {
    return {
      title: 'Скидка'
    }
  },
  metaInfo() {
    return {
      title: this.title
    }
  },
  computed: {
    discount() {
      return this.$store.state.cost.discount
    },
    customerGroups() {
      return this.$store.state.customers.groups
    }
  },
  created() {
    this.$store.commit('setTitle', 'Скидки')
    this.getDiscount()
    this.$store.dispatch('customers/getCustomerGroups')
    this.$validator.localize('ru', {
      attributes: {
        name: 'название',
        discount_type: 'тип',
        period: 'длительность',
        discount_value: 'значение',
      }
    })
  },
  methods: {
    //получение скидки
    getDiscount() {
      this.$store.commit('openRightPanel')
      if (this.$route.params.discountid == 'new') {
        this.$store.state.cost.discount = {}
      } else {
        this.$store.dispatch('cost/getDiscount', { id: this.$route.params.discountid }).then(discount => {
          this.title = 'Скидка ' + discount.name
        })
      }
    },
    //сохранение скидки
    saveDiscount() {

      if (this.discount.date_from) this.discount.date_from = this.moment(this.discount.date_from).format('DD-MM-YYYY');
      else this.discount.date_from = null;
      if (this.discount.date_to) this.discount.date_to = this.moment(this.discount.date_to).format('DD-MM-YYYY');
      else this.discount.date_to = null;
      if (this.discount.active == null) this.discount.active = 0;

      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.$store.dispatch(typeof this.discount.id == 'undefined' ? 'cost/addDiscount' : 'cost/updateDiscount', { discount: this.discount }).then(() => {
            this.$root.$emit('reload-table', 'discounts')
          })
          this.$router.push({ name: 'Discounts', query: this.$route.query })
        }
      })
    }
  },
  watch: {
    '$route.params.discountid'() {
      this.getDiscount()
    }
  }
}
</script>


// WEBPACK FOOTER //
// Discount.vue?a8960cec